import { UserProvisioningMode } from '@shared/enums/UserProvisioningMode';
import { UserProvisioningType } from '@shared/enums/UserProvisioningType';


export interface IGetUserProvisioning {
    isEnabled: boolean;
    type: UserProvisioningType;
    mode: UserProvisioningMode;
}


export interface IUserProvisioning {
    accessCode: string;
    defaultRoleId: string;
    hasGroupProvisioning: boolean;
    remoteTenantId: string;
    hasUserProvisioning: boolean;
    mode: UserProvisioningMode;
    remoteContactGroupId: string;
    hasContactProvisioning: boolean;
    type: UserProvisioningType;
    clientId: string;
    clientSecret: string;
    accessCodeMostRecentAction: string;
    authorityUrl: string;
    remoteContactGroupName: string;
}

export class UserProvisioning implements IUserProvisioning {
    constructor(
        public type: UserProvisioningType,
        public accessCode: string,
        public defaultRoleId: string,
        public hasGroupProvisioning: boolean,
        public remoteTenantId: string,
        public hasUserProvisioning: boolean,
        public mode: UserProvisioningMode,
        public remoteContactGroupId: string,
        public hasContactProvisioning: boolean,
        public clientId: string,
        public clientSecret: string,
        public accessCodeMostRecentAction: string,
        public authorityUrl: string,
        public remoteContactGroupName: string,
    ) { }
}

export interface IUpdateUserProvisioning {
    type: UserProvisioningType;
    defaultRoleId: string;
    hasGroupProvisioning: boolean;
    remoteTenantId: string;
    hasUserProvisioning: boolean;
    mode: UserProvisioningMode;
    remoteContactGroupId: string;
    hasContactProvisioning: boolean;
    clientId: string;
    clientSecret: string;
    accessCodeMostRecentAction: string;
    authorityUrl: string;
    remoteContactGroupName: string;
}

export class UpdateUserProvisioning implements IUpdateUserProvisioning {
    constructor(
        public type: UserProvisioningType,
        public defaultRoleId: string,
        public hasGroupProvisioning: boolean,
        public remoteTenantId: string,
        public hasUserProvisioning: boolean,
        public mode: UserProvisioningMode,
        public remoteContactGroupId: string,
        public hasContactProvisioning: boolean,
        public clientId: string,
        public clientSecret: string,
        public accessCodeMostRecentAction: string,
        public authorityUrl: string,
        public remoteContactGroupName: string,
    ) { }
}
